export default {
    splash: null,
    avatar: null,
};



// WEBPACK FOOTER //
// ./src/store/asset/state.js